import React, {useRef, forwardRef, useState, useEffect, Fragment} from 'react'
// import {useDispatch, useSelector} from "react-redux"
// import WebViewer from '@pdftron/webviewer'
import MaterialTable from 'material-table'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'

// Material-UI Lab
// import ToggleButton from '@material-ui/lab/ToggleButton'

// Material-UI Icon
import GetAppIcon from '@material-ui/icons/GetApp'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
// For Material-Table
import AddBox from '@material-ui/icons/AddBox'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import Check from '@material-ui/icons/Check'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import Clear from '@material-ui/icons/Clear'
import DeleteOutline from '@material-ui/icons/DeleteOutline'
import Edit from '@material-ui/icons/Edit'
import FilterList from '@material-ui/icons/FilterList'
import FirstPage from '@material-ui/icons/FirstPage'
import LastPage from '@material-ui/icons/LastPage'
import Remove from '@material-ui/icons/Remove'
import SaveAlt from '@material-ui/icons/SaveAlt'
import Search from '@material-ui/icons/Search'
import ViewColumn from '@material-ui/icons/ViewColumn'

// Custom Component
import useLoading from "../Loading/useLoading"
import LockScreenLoading from '../LockScreenLoading/LockScreenLoading'
import {Alert} from '../Alert/Alert'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import SaveWarnDialog from '../Dialog/SaveWarnDialog'
import FullScreenDialog from '../Dialog/FullScreenDialog'
import ViewGeneralRevision from './ViewGeneralRevision'

// Custom Style
import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, nightOrangeColor, oceanBlueColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import drawingGeneralRevisionTableStyle from '../../styles/jss/components/drawingRegister/drawingGeneralRevisionTableStyle'

// Fetch Data
import {downloadRevision, deleteRevision} from '../../dataSource/drawingRegister'


const useStyles = makeStyles(theme => drawingGeneralRevisionTableStyle(theme))

const DrawingGeneralRevisionTable = props => {
	const {drawingDetailRecord, setSelectedRevisionSeq, setWebViewerProps, setDrawingRefash, annotSaveChangeAction} = props
	const store = require('store')
	const classes = useStyles()

	const tableRef = useRef()

	const [selectedRowId, setSelectedRowId] = useState(null)
	const [selectedRowRecord, setSelectedRowRecord] = useState(null)
	const [actionsIcon, setActionsIcon] = useState([])
	const [viewGeneralRevisionDialogOpen, setViewGeneralRevisionDialogOpen] = useState(false)
	const [selectedRevisionRecord, setSelectedRevisionRecord] = useState(null)
	const [dataTableToolbarOpen, setDataTableToolbarOpen] = useState(false)
	const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false)
	const [progressTitle, setProgressTitle] = useState("")

	// Alert dialog contral state
	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})
	
	// Confirm dialog contral State
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		attentionContent: "",
		confirmAction: "",
		cancelAction: ""
	})

	// Save Change Warning dialog control State
	const [saveWarnDialogOpen, setSaveWarnDialogOpen] = useState(false)
	const [saveWarnDialogData, setSaveWarnDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		saveAction: "",
		dontSaveAction: "",
		cancelAction: ""
	})


	// Set Alert Content
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}

	// Set Confirm Dialog Content
	const buildConfirmDialog = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			attentionContent: data.attentionContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})
	}

	// Set Save Change Warning Dialog
	const buildSaveChangeWarningDialog = (data) => {
		setSaveWarnDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			saveAction: data.saveAction,
			dontSaveAction: data.dontSaveAction,
			cancelAction: data.cancelAction
		})
	}


	// Confirm Dialog Contral Function
	const confirmDialogHandleOpen = (data) => {
		buildConfirmDialog(data)
		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	// Save Change Dialog Control Function
	const saveChangeWarningDialogHandleOpen = (data) => {
		buildSaveChangeWarningDialog(data)
		setSaveWarnDialogOpen(true)
	}

	const saveChangeWarningDialogHandleClose = () => {
		setSaveWarnDialogOpen(false)
	}


	// View Revision Dialog Control Function
	const viewGeneralRevisionDialogHandleOpen = (recordData) => {
		setSelectedRevisionRecord(recordData)
		setViewGeneralRevisionDialogOpen(true)
	}

	const viewGeneralRevisionDialogHandleClose = () => {
		setViewGeneralRevisionDialogOpen(false)
	}


	const tableIcons = {
		Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
		Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
		Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
		Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
		DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
		Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
		Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
		Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
		FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
		LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
		NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
		PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
		ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
		Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
		SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
		ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
		ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
	}

	const columns = [
		{title: "Revision No", field: "rev_no"},
		{title: "Modify By", field: "modifyuser"},
		{title: "Modify Date.", field: "modifydate"},
	]

	
	// Action
	const saveChangeWarningAction = selectedRow => {
		saveChangeWarningDialogHandleOpen({
			dialogTitle: "Annotation Change Warning",
			dialogContent: "Do you want to save the change of annotation.",
			saveAction: saveChangeWarningSaveAnnotation(selectedRow),
			dontSaveAction: saveChangeWarningDontSaveAnnotation(selectedRow),
			cancelAction: saveChangeWarningCancelAction
		})
	}

	const saveChangeWarningSaveAnnotation = selectedRow => () => {
		saveChangeWarningCancelAction()

		store.set('annotActive', false)

		annotSaveChangeAction().then(() => {
			setSelectedRowId(selectedRow.tableData.id)
			setSelectedRowRecord(selectedRow)
			setSelectedRevisionSeq(selectedRow.rev_seq)
		
			setWebViewerProps({
				from: "API",
				autoLoading: false,
				file_cat: selectedRow.file_cat, 
				file_ref: selectedRow.rev_seq,
				file_name: "abc.pdf"
			})
		})
	}

	const saveChangeWarningDontSaveAnnotation = (selectedRow) => () => {
		saveChangeWarningCancelAction()
		
		store.set('annotActive', false)
		
		setSelectedRowId(selectedRow.tableData.id)
		setSelectedRowRecord(selectedRow)
		setSelectedRevisionSeq(selectedRow.rev_seq)

		setWebViewerProps({
			from: "API",
			autoLoading: false,
			file_cat: selectedRow.file_cat, 
			file_ref: selectedRow.rev_seq,
			file_name: "abc.pdf"
		})
	}

	const saveChangeWarningCancelAction = () => {
		saveChangeWarningDialogHandleClose()
	}


	const removeRevisionConfirmAction = (selectedRow) => {
		confirmDialogHandleOpen({
			dialogTitle: "Remove Revision",
			dialogContent: "Are you sure to remove revision.",
			attentionContent: "Under this revision, all record will be remove together. Include all related items record",
			confirmAction: () => removeRevisionAction(selectedRow),
			cancelAction: removeRevisionCancelAction
		})
	}

	const removeRevisionAction = (selectedRow) => {
		confirmDialogHandleClose()

		selectedRow.map(rowRes => {
			deleteRevision(drawingDetailRecord.dwg_seq,  rowRes.rev_seq).then(res => {
				setDrawingRefash(res.code)

				buildAlert({
					// Alert Type: success, info, warning, error
					type: "success",
					title: "Success Alert",
					content: "The drawing have been removed"
				})
			})
		})
	}

	const removeRevisionCancelAction = () => {
		confirmDialogHandleClose()
	}


	const downloadRevisionAction = (selectedRow, fullset) => {
		const coverSeq = []

		setProgressTitle("Downloading...")
		setLockScreenLoadingOpen(true)

		selectedRow.map(res => {
			coverSeq.push(res.rev_seq)
		})

		downloadRevision(drawingDetailRecord.dwg_seq, coverSeq, fullset).then(() => {
			console.log("Revision set Download Successful")

			tableRef.current.onAllSelected(false)
			setLockScreenLoadingOpen(false)
			setProgressTitle("")
		})
	}


	const viewGeneralRevisionDialogBtn = [
		// {
		// 	buttonName: "Annotation Publish",
		// 	buttonFunction: annotationPublishActionHandleOpen,
		// 	chooseFile: false
		// },
	]


	useEffect(() => {

	}, [])


	return (
		// console.log("Drawing Detail Record | Variable: drawingDetailRecord (DrawingGeneralRevisionTable.js)"),
		// console.log(drawingDetailRecord),

		// console.log("Selected Row ID | Variable: selectedRowId (DrawingGeneralRevisionTable.js)"),
		// console.log(selectedRowId),

		// console.log("Selected Row Record | Variable: selectedRowRecord (DrawingGeneralRevisionTable.js)"),
		// console.log(selectedRowRecord),

		// console.log("DWG Type Group Selected Value | Variable: value (DataTable.js)"),
		// console.log(value),

		// console.log("DWG Type Group input Value | Variable: inputValue (DataTable.js)"),
		// console.log(inputValue),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div>
				<LockScreenLoading 
					open={lockScreenLoadingOpen}
					circleSize={200}
					progressTitle={progressTitle}
				/>

				<Alert
					open={alertOpen}
					alertType={alertData.type}
					alertTitle={alertData.title}
					alertContent={alertData.content}
					handleClose={() => setAlertOpen(false)}
				/>

				<ConfirmDialog
					open={confirmDialogOpen}
					dialogTitle={confirmDialogData.dialogTitle}
					dialogContent={confirmDialogData.dialogContent}
					attentionContent={confirmDialogData.attentionContent}
					confirmAction={confirmDialogData.confirmAction}
					cancelAction={confirmDialogData.cancelAction}
				/>

				<SaveWarnDialog
					open={saveWarnDialogOpen}
					dialogTitle={saveWarnDialogData.dialogTitle}
					dialogContent={saveWarnDialogData.dialogContent}
					saveAction={saveWarnDialogData.saveAction}
					dontSaveAction={saveWarnDialogData.dontSaveAction}
					cancelAction={saveWarnDialogData.cancelAction}
				/>

				<FullScreenDialog
					open={viewGeneralRevisionDialogOpen}
					dialogTitle={"Revision of Drawing"}
					formContent={
						<ViewGeneralRevision
							drawingRecord={drawingDetailRecord}
							revisionRecord={selectedRevisionRecord}
							viewGeneralRevisionDialogHandleClose={viewGeneralRevisionDialogHandleClose}
							setDrawingRefash={setDrawingRefash}
						/>
					}
					button={viewGeneralRevisionDialogBtn}
					handleClose={viewGeneralRevisionDialogHandleClose}
				/>
			</div>

			<MaterialTable
				tableRef={tableRef}
				icons={tableIcons}
				title=""
				columns={columns}
				data={drawingDetailRecord.dwg_revisions}
				actions={actionsIcon}

				onSelectionChange={data => {
					if (data.length > 0) {
						if (data.length == 1) {
							setActionsIcon([
								{
									icon: () => <EditIcon color="primary"/>,
									tooltip: 'Edit',
									onClick: (event, rowData) => {
										viewGeneralRevisionDialogHandleOpen(rowData[0])
									}
								},
								{
									icon: () => <GetAppIcon color="primary"/>,
									tooltip: "download Revision (Include all related item documents)",
									onClick: (event, rowData) => {
										downloadRevisionAction(rowData, true)
									}
								},
								{
									icon: () => <DeleteIcon color="primary"/>,
									tooltip: 'Delete',
									onClick: (event, rowData) => {
										removeRevisionConfirmAction(rowData)
									}
								}
							])
						}
						else {
							setActionsIcon([
								{
									icon: () => <GetAppIcon color="primary"/>,
									tooltip: "download PDF File",
									onClick: (event, rowData) => {
										console.log("Press Download: ", rowData)
									}
								},
								{
									icon: () => <DeleteIcon color="primary"/>,
									tooltip: 'Delete',
									onClick: (event, rowData) => {
										removeRevisionConfirmAction(rowData)
									}
								}
							])
						}

						setDataTableToolbarOpen(true)
					}
					else {
						setDataTableToolbarOpen(false)
					}
				}}

				// onSearchChange={handleSearchChange}
				// onFilterChange={handleFilterChange}

				onRowClick={(event, selectedRow) => {

					if (!store.get('annotActive')) {
						setSelectedRowId(selectedRow.tableData.id)
						setSelectedRowRecord(selectedRow)
						setSelectedRevisionSeq(selectedRow.rev_seq)
	
						setWebViewerProps({
							from: "API",
							autoLoading: false,
							file_cat: selectedRow.file_cat, 
							file_ref: selectedRow.rev_seq,
							file_name: "abc.pdf"
						})
					}
					else {
						saveChangeWarningAction(selectedRow)
					}
				}}
				

				localization={{
					header : {
						actions: ""
					}
				}}

				options={{
					showTitle: false,
					toolbar: dataTableToolbarOpen,
					grouping: true,
					paging: false,
					selection: true,

					search: false,
					filtering: false,

					minBodyHeight: "100px",
					maxBodyHeight: "250px",

					headerStyle: {
						backgroundColor: oceanBlueColor[10],
						fontFamily: "Gill Sans, sans-serif",
						fontWeight: "bold",
						fontSize: "16px",
						// color: grayColor[8],
						color: whiteColor,
					},

					rowStyle: rowData => ({
						backgroundColor: selectedRowId === rowData.tableData.id ? oceanBlueColor[0] : "",
						fontSize: "14px",
						fontFamily: "Gill Sans, sans-serif",
					}),

					// cellStyle: { 
					// 		// backgroundColor: '#039be5',
					// 	fontFamily: "Gill Sans, sans-serif",
					// 		// color: '#FFF',
					// 		// height: 200,
					// 		// maxHeight: 200
					// 	}
				}}

			/>
		
		</Fragment>
	)
}


export default DrawingGeneralRevisionTable